<header>
  <ng-container *ngIf="isSingleSelectionOnly; else multipleSelection">
    <h1 i18n>Choose ONE template to get started with</h1>
    <h2 class="add-more-badge" i18n>
      You can add more free templates later, create your own and/or make changes to them.
    </h2>
  </ng-container>
  <ng-template #multipleSelection>
    <h1 i18n>Choose some templates to start with</h1>
    <h2 i18n>You can edit these templates later, after they are added into your account.</h2>
  </ng-template>
</header>

<cc-templates-selector
  [isLibrarySelection]="true"
  [templates]="templates"
  [loading]="loading"
  [selectedBusinessAttributes]="selectedBusinessAttributes"
  [isSingleSelectionOnly]="isSingleSelectionOnly"
  (isAnyTemplateSelected)="updateAddButtonStatus($event)"
  (facetsChange)="onFacetsChange($event)"
>
</cc-templates-selector>

<footer>
  <button
    type="button"
    (click)="addTemplates()"
    [disabled]="!enableAddTemplateBtn"
    class="btn cc-btn-primary-constructive btn-add-template"
    [class.single-selection]="isSingleSelectionOnly"
    i18n
  >
    {{ isSingleSelectionOnly ? 'Next' : 'Start with these templates' }}
  </button>
  <span *ngIf="!isSingleSelectionOnly" class="ml-1 skip-link btn" (click)="skip()">Skip</span>
</footer>
